import { ViewModel,View } from "binder"
import moment from "moment";
import { Converters } from "src/converters";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { FileSelectorViewModel } from "uicomponents";
import { IPaymentMethod, singlePayment } from "../invoicePayment/invoicePayment-viewModel";
import  { IbanPaymentView } from "./ibanPayment-view"
import { IbanSelectorSelectorViewModel } from "./ibanSelector-viewModel";

export class IbanPaymentViewModel extends ViewModel implements IPaymentMethod{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ibanSelectorViewModel = new IbanSelectorSelectorViewModel(this);
        this.paymentTypeName = 'شبا';
        this.paymentTime = moment.utc();
        this.fileSelector = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new IbanPaymentView();
    }
    public getTypeId(): string {
        return "VM-425C6571-2E78-4699-9056-C95F8FE4769D"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set paymentTypeName(v: string) { this._paymentTypeName = v; } public get paymentTypeName(): string { return this._paymentTypeName;} private _paymentTypeName: string;
    
    public set ibanSelectorViewModel(v: IbanSelectorSelectorViewModel) { this._ibanSelectorViewModel = v; } public get ibanSelectorViewModel(): IbanSelectorSelectorViewModel { return this._ibanSelectorViewModel;} private _ibanSelectorViewModel: IbanSelectorSelectorViewModel;
    public set maxAmount(v: number) { 
        this._maxAmount = v; 
        if(this.maxAmount > 0)
            this.amount = this.maxAmount;
    } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { 
        this._amount = getAsNumber(v,true);
        // this.checkAmountValidity();
    } public get amount(): number { return this._amount;} private _amount: number;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set paymentTime(v: moment.Moment) { this._paymentTime = v; } public get paymentTime(): moment.Moment { return this._paymentTime;} private _paymentTime: moment.Moment;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isFromRootDistrict(v: boolean) { 
        this._isFromRootDistrict = v; 
        this.ibanSelectorViewModel.refresh();
    } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    
    private checkAmountValidity(){
        if(this.amount>this.maxAmount){
            this.amount = this.maxAmount;
        }
    }    
    load(){}
    clear() {
        this.traceCode = '';
    }

    public async createPayment(){
        let validationResult = this.validateInput();
        if(validationResult==''){
            try {
                this.isLoading = true;
                let converter = new Converters();
                let confirmationResult = await this.messageBoxSuccessYesNo(`آیا پرداخت شبا با مبلغ ${this.amount} با کد پیگیری ${this.traceCode} به شماره شبای ${this.ibanSelectorViewModel.selectedItem.title} در تاریخ ${converter.DatePartLocalDateConverter(this.paymentTime)} صحیح است؟`,'پرداخت نقدی');
                if(confirmationResult=='no'){
                    return;
                }
                
                let result = await ServerConnection.callServer('/Complex/SellServices/AddIbanTransfer',{
                    IbanGatewayId:this.ibanSelectorViewModel.selectedItem.id,
                    InvoiceId:this.invoiceId,
                    TraceCode:this.traceCode,
                    Amount:this.amount,
                    PaymentTime:this.paymentTime,
                    FileName : this.fileSelector.filename,
                    FileContent : this.fileSelector.filecontent
                });
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess('پرداخت با موفقیت ثبت شد','پرداخت شبا');
                    var payment = new singlePayment(this.parentViewModel);
                    payment.setConfirmationStatus(result.Confirmed ? true : null);
                    payment.method = 'شبا';
                    payment.amount = this.amount;
                    payment.time = moment.utc(moment.now());
                    this.onNewPaymentCreated(payment);
                } else {
                    if (result.Faults[0].Parameters.FaultId === "8E9EEFBC-C6A3-4088-B60A-E1B649EE679A"){
                        throw "زمان یا مبلغ اعتبار مشتری یه پایان رسیده است. لطفا پرداخت را برای فاکتورهای نهایی شده وی انجام دهید.";
                    }else if (result.Faults[0].Parameters.FaultId === "6CFFE6CC-63FC-4C3D-8976-6E1677020051")
                        throw "مانده حساب بیشتر از اعتبار مشتری است.";
                    throw "خطا در انجام عملیات";
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(ex,"خطا")
            } finally {
                this.isLoading = false;
            }
        }else{
            await this.messageBoxConfirmWarning(validationResult,"خطا")
        }
    }

    private validateInput():string{
        let errors :string[]= []
        if(this.ibanSelectorViewModel.selectedItem==null){
            errors.push('کد شبای مقصد مشخص نشده است.');
        }
        if(this.traceCode==''){
            errors.push('کد پیگیری مشخص نشده است');
        }
        if(this.amount<=0){
            errors.push('مبلغ به درستی تنظیم نشده است');
        }
        return errors.join("\n");
    }

    onNewPaymentCreated(payment: singlePayment) {
    }
}